// step3のModal内共通データ定義
export const ModalRead = {
  license: {
    title: "免許証の色を選択する場合の注意点",
    read1: "免許証の更新手続きが可能な期間中に保険期間※の開始日がある場合、免許証の色の選択に注意が必要です。",
    read2: "※当見積りでは保険の開始日を30日後に仮設定しています。",
    url: "https://faq-ins-saison.dga.jp/car/otona/faq_detail.html?id=9867&_ga=2.60388653.1275035217.1618193187-526172691.1613436998"
  },
  purpose: {
    title: "使用目的とは",
    read1:
      "お車そのものを使用する目的のことです。「日常・レジャー」 、「通勤・通学」 、「業務使用」の３区分から、月平均15日以上使用するものをご選択ください。",
    url: "https://faq-ins-saison.dga.jp/car/otona/faq_detail.html?id=1350&_ga=2.60388653.1275035217.1618193187-526172691.1613436998"
  },
  transfer: {
    title: "通勤・通学のための”送迎”で利用している場合",
    read1: "通勤・通学先や経由地（最寄り駅など）への送迎は、「通勤・通学」に含みません。",
    url: "https://faq-ins-saison.dga.jp/car/otona/faq_detail.html?id=1519&_ga=2.103448064.1275035217.1618193187-526172691.1613436998"
  },
  nonfleet: {
    title: "ノンフリート等級とは",
    read1:
      "ご契約者が所有・使用するお車のご契約台数が、他の保険会社でのご契約台数を含めて 9台以下の場合をノンフリート契約といい、その契約に適用する無事故割引（割増）の等級を「ノンフリート等級」といいます。一般的に、保険期間中に無事故の場合は、翌年のご契約の等級は1等級上がり、事故が発生した場合は、事故1件につき3等級下がります。",
    url: "https://faq-ins-saison.dga.jp/car/otona/faq_detail.html?id=1022&_ga=2.103448064.1275035217.1618193187-526172691.1613436998"
  },
  driverRangeSelection: {
    title: "「運転者の範囲」の選び方について",
    read1:
      "運転者の範囲は記名被保険者（ご契約のお車を主に使用される方）と他にご契約のお車を運転される方との続柄によりお選びください。",
    url: "https://faq-ins-saison.dga.jp/car/otona/faq_detail.html?cid=WHP001&id=4894&category=&page=3"
  }
}
